// @flow
import { createReducer } from "reduxsauce";
import I18n from "../i18n/I18n";
import Types from "../actions/Types";

// Init State
export const INITIAL_STATE = {
  transfer: null,
  errorMessage: null,
  successMessage: null,
  isLoading: false,
  isCountLoading: false,
  status: null,
  rtvStatus: null,
};

/* Generic error message */
const genericError = "Something went wrong";

/* Post transfer */
export const postOutbound = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
    successMessage: null,
    errorMessage: null
  };
};

export const postOutboundSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Transfer success";
  return {
    ...state,
    transfer: action.transfer,
    successMessage,
    isLoading: false
  };
};

export const postOutboundFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isLoading: false
  };
};

/* Get transfers */
export const getTransfers = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
    success: null
  };
};

export const getTransfersSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    transfers: action.transfers,
    isLoading: false
  };
};

export const getTransfersFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

/* Get transfers */
export const getAsn = (state: Object = INITIAL_STATE, action) => {
  return {
    ...state,
    isLoading: !action.print && action.query.indexOf("is_export") === -1,
    isExportLoading: action.query.indexOf("is_export") !== -1,
    isPrintLoading: action.print && action.query,
    isUnidentifiedLoading:
      action.query.indexOf("unidentified") !== -1 && action.print
  };
};

export const getAsnSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const val = {
    ...state,
    isLoading: false,
    isUnreceivedLoading: false
  };

  if (state.isUnidentifiedLoading) {
    val.unidentifiedAsn = action.asn;
  } else if (state.isExportLoading) {
    val.exportAsn = action.asn;
  } else {
    val.asn = action.asn;
  }
  if (
    (action.asn && state.isUnidentifiedLoading && state.isPrintLoading) ||
    (val.identifiedAsn && val.unidentifiedAsn) ||
    (action.asn &&
      state.isPrintLoading &&
      state.isPrintLoading.indexOf("type") !== -1)
  ) {
    val.isPrintLoading = false;
  }
  val.isExportLoading = false;
  return val;
};

export const getAsnFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  isPrintLoading: false,
  isExportLoading: false,
  errorMessage: action.error || genericError
});

/* Get count */
export const getTransfersCount = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isCountLoading: true
  };
};

export const getTransfersCountSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    transfersCount: action.transfersCount,
    isCountLoading: false
  };
};

export const getTransfersCountFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isCountLoading: false,
  errorMessage: action.error || genericError
});

/*getFbnTransfersCount */
export const getFbnTransfersCount = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isCountLoading: true
  };
};

export const getFbnTransfersCountSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    transfersCount: action.transfersCount,
    isCountLoading: false
  };
};

export const getFbnTransfersCountFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isCountLoading: false,
  errorMessage: action.error || genericError
});

/* Close ASN */
export const closeAsn = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isClosing: true,
    successMessage: null,
    errorMessage: null
  };
};

export const closeAsnSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Transfer success";
  return {
    ...state,
    close: action.close,
    successMessage,
    isClosing: false
  };
};

export const closeAsnFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isClosing: false
  };
};

/* FBN ASN Open */
export const openFbnAsn = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isOpening: true,
    successMessage: null,
    errorMessage: null
  };
};

export const openFbnAsnSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Transfer success";
  return {
    ...state,
    initialLines: action.initialLines,
    successMessage,
    isOpening: false
  };
};

export const openFbnAsnFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isOpening: false
  };
};

/* IMPORT FBN ASN */
export const importFbnAsn = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isImporting: true,
    successMessage: null,
    errorMessage: null,
    isImportCompleted: false
  };
};

export const importFbnAsnSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Transfer success";
  return {
    ...state,
    success: action.success,
    successMessage,
    isImporting: false,
    isImportCompleted: true
  };
};

export const importFbnAsnFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isImporting: false,
    isImportCompleted: false
  };
};

/* SCHEDULE ASN */
export const scheduleAsn = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isScheduling: true,
    successMessage: null,
    errorMessage: null,
    // success: null,
    isImportCompleted: false
  };
};

export const scheduleAsnSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Transfer success";
  return {
    ...state,
    success: action.success,
    successMessage,
    isScheduling: false
  };
};

export const scheduleAsnFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isScheduling: false,
    success: null
  };
};

/* FBN ASN Open */
export const getInitialLines = (state: Object = INITIAL_STATE, action) => {
  return {
    ...state,
    // isLoading: true,
    successMessage: null,
    errorMessage: null,
    // success: null,
    isInitialLoading: action.typeText || "initial",
    isInitialLoaded: false
  };
};

export const getInitialLinesSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Transfer success";
  return {
    ...state,
    initialLines: action.initialLines,
    successMessage,
    isInitialLoaded: state.isInitialLoading,
    isInitialLoading: false
  };
};

export const getInitialLinesFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isInitialLoaded: false,
    isInitialLoading: false
  };
};

/* GET PROCESSED LINES */
export const getProcessedLines = (state: Object = INITIAL_STATE, action) => {
  return {
    ...state,
    isLoading: !action.print && action.query.indexOf("is_export") === -1,
    isExportLoading: action.query.indexOf("is_export") !== -1,
    isPrintLoading: action.print && action.query,
    successMessage: null,
    errorMessage: null
  };
};

export const getProcessedLinesSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Transfer success";
  const val = {
    ...state,
    isPrintLoading: false,
    isExportLoading: false,
    successMessage,
    isLoading: false
  };
  if (!state.isExportLoading) {
    val.lines = action.lines;
  }
  return val;
};

export const getProcessedLinesFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isLoading: false,
    isExportLoading: false,
    isPrintLoading: false
  };
};

/* GET PROCESSED LINES */
export const getAsnBatches = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isBatchesLoading: true,
    successMessage: null,
    errorMessage: null
  };
};

export const getAsnBatchesSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Transfer success";
  return {
    ...state,
    batches: action.batches,
    successMessage,
    isBatchesLoading: false
  };
};

export const getAsnBatchesFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    isBatchesLoading: false,
    errorMessage: action.errorMessage || genericError
  };
};

/* EXPORT ELIGIBLE */
export const exportEligibleOffers = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isExporting: true,
    successMessage: null,
    errorMessage: null
  };
};

export const exportEligibleOffersSuccess = state => {
  const successMessage = "Transfer success";
  return {
    ...state,
    successMessage,
    isExporting: false
  };
};

export const exportEligibleOffersFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isExporting: false
  };
};

/* SCHEDULE ASN */
export const retrieveSlots = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isGettingSlots: true,
    errorMessage: null
  };
};

export const retrieveSlotsSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    slots: action.slots,
    isGettingSlots: false
  };
};

export const retrieveSlotsFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    slots: null,
    isGettingSlots: false
  };
};

/* GET STATUS */
export const getStatus = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    errorMessage: null
  };
};

export const getStatusSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    status: action.status,
  };
};

export const getStatusFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
  };
};

/* GET RTV STATUS */
export const getRtvStatuses = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    errorMessage: null
  };
};

export const getRtvStatusesSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    rtvStatus: action.rtvStatus,
  };
};

export const getRtvStatusesFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
  };
};

const ACTION_HANDLERS = {
  [Types.POST_OUTBOUND]: postOutbound,
  [Types.POST_OUTBOUND_SUCCESS]: postOutboundSuccess,
  [Types.POST_OUTBOUND_FAILURE]: postOutboundFailure,
  [Types.GET_TRANSFERS]: getTransfers,
  [Types.GET_TRANSFERS_SUCCESS]: getTransfersSuccess,
  [Types.GET_TRANSFERS_FAILURE]: getTransfersFailure,
  [Types.GET_ASN]: getAsn,
  [Types.GET_ASN_SUCCESS]: getAsnSuccess,
  [Types.GET_ASN_FAILURE]: getAsnFailure,
  [Types.GET_TRANSFERS_COUNT]: getTransfersCount,
  [Types.GET_TRANSFERS_COUNT_SUCCESS]: getTransfersCountSuccess,
  [Types.GET_TRANSFERS_COUNT_FAILURE]: getTransfersCountFailure,
  [Types.GET_FBN_TRANSFERS_COUNT]: getFbnTransfersCount,
  [Types.GET_FBN_TRANSFERS_COUNT_SUCCESS]: getFbnTransfersCountSuccess,
  [Types.GET_FBN_TRANSFERS_COUNT_FAILURE]: getFbnTransfersCountFailure,
  [Types.CLOSE_ASN]: closeAsn,
  [Types.CLOSE_ASN_SUCCESS]: closeAsnSuccess,
  [Types.CLOSE_ASN_FAILURE]: closeAsnFailure,
  [Types.OPEN_FBN_ASN]: openFbnAsn,
  [Types.OPEN_FBN_ASN_SUCCESS]: openFbnAsnSuccess,
  [Types.OPEN_FBN_ASN_FAILURE]: openFbnAsnFailure,
  [Types.GET_INITIAL_LINES]: getInitialLines,
  [Types.GET_INITIAL_LINES_SUCCESS]: getInitialLinesSuccess,
  [Types.GET_INITIAL_LINES_FAILURE]: getInitialLinesFailure,
  [Types.IMPORT_FBN_ASN]: importFbnAsn,
  [Types.IMPORT_FBN_ASN_SUCCESS]: importFbnAsnSuccess,
  [Types.IMPORT_FBN_ASN_FAILURE]: importFbnAsnFailure,
  [Types.SCHEDULE_ASN]: scheduleAsn,
  [Types.SCHEDULE_ASN_SUCCESS]: scheduleAsnSuccess,
  [Types.SCHEDULE_ASN_FAILURE]: scheduleAsnFailure,
  [Types.EXPORT_ELIGIBLE_OFFERS]: exportEligibleOffers,
  [Types.EXPORT_ELIGIBLE_OFFERS_SUCCESS]: exportEligibleOffersSuccess,
  [Types.EXPORT_ELIGIBLE_OFFERS_FAILURE]: exportEligibleOffersFailure,
  [Types.GET_PROCESSED_LINES]: getProcessedLines,
  [Types.GET_PROCESSED_LINES_SUCCESS]: getProcessedLinesSuccess,
  [Types.GET_PROCESSED_LINES_FAILURE]: getProcessedLinesFailure,
  [Types.GET_ASN_BATCHES]: getAsnBatches,
  [Types.GET_ASN_BATCHES_SUCCESS]: getAsnBatchesSuccess,
  [Types.GET_ASN_BATCHES_FAILURE]: getAsnBatchesFailure,
  [Types.RETRIEVE_SLOTS]: retrieveSlots,
  [Types.RETRIEVE_SLOTS_SUCCESS]: retrieveSlotsSuccess,
  [Types.RETRIEVE_SLOTS_FAILURE]: retrieveSlotsFailure,
  [Types.GET_STATUS]: getStatus,
  [Types.GET_STATUS_SUCCESS]: getStatusSuccess,
  [Types.GET_STATUS_FAILURE]: getStatusFailure,
  [Types.GET_RTV_STATUS]: getRtvStatuses,
  [Types.GET_RTV_STATUS_SUCCESS]: getRtvStatusesSuccess,
  [Types.GET_RTV_STATUS_FAILURE]: getRtvStatusesFailure
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/TransferReducer.js